type ColumnNode = {
  id?: string;
  name?: string;
  description?: string;
};

export const buildColumnDescriptionByName = (
  ...nodeGroups: Array<ColumnNode[] | null | undefined>
): Record<string, string> => {
  const map: Record<string, string> = {};

  nodeGroups.forEach(nodes => {
    nodes?.forEach(node => {
      const description = typeof node?.description === 'string' ? node.description.trim() : '';
      if (!description) {
        return;
      }
      if (node?.name) {
        map[node.name] = description;
      }
      if (node?.id) {
        map[node.id] = description;
      }
    });
  });

  return map;
};

export const resolveColumnNodeDescription = (
  node: ColumnNode | undefined,
  fallbackNodes?: ColumnNode[] | null,
  descriptionByName?: Record<string, string>,
): string | undefined => {
  const direct = typeof node?.description === 'string' ? node.description.trim() : '';
  if (direct) {
    return direct;
  }

  if (descriptionByName) {
    const fromMap = (node?.name && descriptionByName[node.name]) || (node?.id && descriptionByName[node.id]);
    if (fromMap) {
      return fromMap;
    }
  }

  if (!node || !Array.isArray(fallbackNodes)) {
    return undefined;
  }

  const match = fallbackNodes.find(
    candidate =>
      (candidate?.id && node.id && candidate.id === node.id) ||
      (candidate?.name && node.name && candidate.name === node.name),
  );
  const fallback = typeof match?.description === 'string' ? match.description.trim() : '';
  return fallback || undefined;
};
